module.exports = __webpack_public_path__ + "img/new-baby-1-min.1537ef02.png";